import * as ActionType from 'actions/ActionTypeConstants';

export const setSplashDisplayed = (displayed: boolean) => ({
  type: ActionType.SET_SPLASH_DISPLAYED as typeof ActionType.SET_SPLASH_DISPLAYED,
  payload: { displayed },
});

export type splashAction = ReturnType<typeof setSplashDisplayed>;
